import { render, staticRenderFns } from "./CancellationPolicy.vue?vue&type=template&id=7a968e6b&"
import script from "./CancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./CancellationPolicy.vue?vue&type=script&lang=js&"
import style0 from "./CancellationPolicy.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports